// Decorative only. The session comes from the server's exchange calendar,
// never from the device clock or an inferred weekday.
export const PREMARKET_ACTIVITIES = Object.freeze(['weights', 'stretch', 'jog', 'charts']);

export const selectPremarketActivity = (bot) => {
  const id = bot?.bot_id;
  const open = bot?.market?.next_open;
  const timezone = bot?.market?.exchange_timezone;
  if (!Number.isSafeInteger(id) || id < 0 || typeof open !== 'string'
      || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/.test(open)
      || typeof timezone !== 'string' || !Number.isFinite(Date.parse(open))) return null;
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit',
    }).formatToParts(new Date(open));
    const value = (part) => Number(parts.find((item) => item.type === part)?.value);
    const sessionDay = Math.floor(Date.UTC(value('year'), value('month') - 1, value('day')) / 86400000);
    if (!Number.isFinite(sessionDay)) return null;
    return PREMARKET_ACTIVITIES[(id + sessionDay) % PREMARKET_ACTIVITIES.length];
  } catch (error) {
    return null;
  }
};
